import { setupArtistSignUpModal } from "desktop/components/artistSignupModal/artistSignupModal"

export const artistClient = () => {
  setupArtistSignUpModal()
}
